export const errors = {
  SERVER_ERROR: "Đã xảy ra lỗi máy chủ",
  EXCEPTION_ERROR: "Đã xảy ra lỗi ngoại lệ",
};
